'use strict';

var URL = {};

URL.querystring = function (href) {
  var queryIndex = href.indexOf('?');

  return href.substr(queryIndex + 1);
};

module.exports = URL;
